import {
  BlockContentValue,
  OpeningText,
  OpeningTextBody,
  OpeningTextSubHeading,
  PartialSanityImageType,
  ResponsiveSanityImage,
  SanityImageRatio,
  SectionContainer,
  SectionDivider,
  TextStyle
} from "@silversea-ssc/ui-components-react";
import { BlockContent } from "components/BlockContent";
import React from "react";
import * as styles from "./MapSection.module.scss";

type Props = {
  title?: string;
  content?: BlockContentValue;
  map?: PartialSanityImageType;
};

const MapSection: React.FC<Props> = ({ title, content, map }) => {
  return (
    <React.Fragment>
      <SectionContainer
        backgroundColor="neutral01"
        spacingTop="regular"
        spacingBottom="condensed"
      >
        <OpeningText>
          <OpeningTextSubHeading>{title}</OpeningTextSubHeading>
          <OpeningTextBody>
            <TextStyle fontSize="inherit">
              <BlockContent value={content} />
            </TextStyle>
          </OpeningTextBody>
        </OpeningText>
      </SectionContainer>

      {map && (
        <SectionDivider
          backgroundColorTop="neutral01"
          backgroundColorBottom="titanium"
          spacingBottom="condensed"
        >
          <SectionContainer backgroundColor="transparent">
            <SanityImageRatio ratio="auto" image={map} className={styles.map}>
              <ResponsiveSanityImage
                image={map}
                fit="original"
                defaultWidth={1024}
                defaultHeight={600}
              />
            </SanityImageRatio>
          </SectionContainer>
        </SectionDivider>
      )}
    </React.Fragment>
  );
};

export default MapSection;
